import { WritingTaskType } from '@/types/writing';
import { getTaskPrompts } from './task-response';
import { COHERENCE_COHESION_PROMPTS } from './coherence-cohesion';
import { LEXICAL_RESOURCE_PROMPTS } from './lexical-resource';
import { GRAMMATICAL_RANGE_PROMPTS } from './grammatical-range';

export type CriterionType = 'TR' | 'CC' | 'LR' | 'GRA';

export function buildCriterionPrompt(
  taskType: WritingTaskType,
  criterionType: CriterionType
): string {
  let promptsArray;

  switch (criterionType) {
    case 'TR':
      promptsArray = getTaskPrompts(taskType);
      break;
    case 'CC':
      promptsArray = COHERENCE_COHESION_PROMPTS;
      break;
    case 'LR':
      promptsArray = LEXICAL_RESOURCE_PROMPTS;
      break;
    case 'GRA':
      promptsArray = GRAMMATICAL_RANGE_PROMPTS;
      break;
  }

  return promptsArray.join('\n\n');
}

export function getCriterionName(
  criterionType: CriterionType,
  taskType: WritingTaskType
): string {
  switch (criterionType) {
    case 'TR':
      return taskType === 'task1' ? 'Task Achievement' : 'Task Response';
    case 'CC':
      return 'Coherence and Cohesion';
    case 'LR':
      return 'Lexical Resource';
    case 'GRA':
      return 'Grammatical Range and Accuracy';
  }
}

export function getCriterionDescription(
  criterionType: CriterionType,
  taskType: WritingTaskType
): string {
  switch (criterionType) {
    case 'TR':
      return taskType === 'task1'
        ? 'How well you address all parts of the task with accurate data selection and an overview of main trends.'
        : 'How well you address all parts of the task with relevant, extended, and well-supported ideas.';
    case 'CC':
      return 'How well your essay is organized, with logical progression, clear paragraphing, and effective use of cohesive devices.';
    case 'LR':
      return 'The range, precision and appropriate use of vocabulary, including spelling and word formation.';
    case 'GRA':
      return 'The range and accurate use of grammar and sentence structures.';
  }
}
